import React from 'react';

const statusStyles = {
  PENDING_PAYMENT: { bg: '#F3F4F6', text: '#6B7280', label: 'Pending Payment' },
  AWAITING_VERIFICATION: { bg: '#FFEDD5', text: '#C2410C', label: 'Awaiting Verification' },
  CONFIRMED: { bg: '#EAE8FF', text: '#5A4BD1', label: 'Confirmed' },
  PACKED: { bg: '#DBEAFE', text: '#1E40AF', label: 'Packed' },
  SHIPPED: { bg: '#DBEAFE', text: '#1D4ED8', label: 'Shipped' },
  DELIVERED: { bg: '#D1FAE5', text: '#047857', label: 'Delivered' },
  CANCELLED: { bg: '#FEE2E2', text: '#B91C1C', label: 'Cancelled' },
  REFUNDED: { bg: '#FEE2E2', text: '#B91C1C', label: 'Refunded' },
  ACTIVE: { bg: '#D1FAE5', text: '#047857', label: 'Active' },
  INACTIVE: { bg: '#F3F4F6', text: '#6B7280', label: 'Inactive' },
  OUT_OF_STOCK: { bg: '#FEE2E2', text: '#B91C1C', label: 'Out of Stock' },
  VERIFIED: { bg: '#D1FAE5', text: '#047857', label: 'Verified' },
  REJECTED: { bg: '#FEE2E2', text: '#B91C1C', label: 'Rejected' },
  PENDING: { bg: '#F3F4F6', text: '#6B7280', label: 'Pending' },
  SCREENSHOT_UPLOADED: { bg: '#FFEDD5', text: '#C2410C', label: 'Screenshot Uploaded' },
  CONNECTED: { bg: '#DCF8E8', text: '#1DA851', label: 'Connected' },
  DISCONNECTED: { bg: '#FEE2E2', text: '#B91C1C', label: 'Disconnected' },
  PENDING_PROVISION: { bg: '#FEF3C7', text: '#92400E', label: 'Pending Activation' },
  AWAITING_RECONNECT: { bg: '#FEF3C7', text: '#92400E', label: 'Awaiting Reconnect' },
  ARCHIVED: { bg: '#F3F4F6', text: '#6B7280', label: 'Archived' },
  IN_PROGRESS: { bg: '#FFEDD5', text: '#C2410C', label: 'In Progress' },
  COMPLETED: { bg: '#D1FAE5', text: '#047857', label: 'Completed' },
};

export default function StatusBadge({ status, label, size = 'md' }) {
  const s = statusStyles[status] || { bg: '#F3F4F6', text: '#6B7280', label: status || '—' };
  const padding = size === 'sm' ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-[11px]';
  return (
    <span className={`inline-flex items-center rounded-full font-semibold ${padding}`} style={{ background: s.bg, color: s.text }} data-testid={`badge-${status}`}>
      {label || s.label}
    </span>
  );
}
